import { render, staticRenderFns } from "./myhead.vue?vue&type=template&id=65a7099a&scoped=true"
import script from "./myhead.vue?vue&type=script&lang=js"
export * from "./myhead.vue?vue&type=script&lang=js"
import style0 from "./myhead.vue?vue&type=style&index=0&id=65a7099a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a7099a",
  null
  
)

export default component.exports